export default "__VITE_ASSET__Dx$9Vkfl__"